import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '../../../../../components/Common/UI/Dialog';
import Icons from '../../../../../components/Common/Icons/Icons';
import Separator from '../../../../../components/Common/UI/Separator';
import { Button } from '../../../../../components/Common/UI/Button';
import { cn } from '../../../../../utils/styles';

interface IModalDelete {
  trigger: React.ReactNode;
  title: React.ReactNode;
  content?: React.ReactNode;
  cancelText?: string;
  okText?: string;
  contentStyle?: string;
  triggerStyle?: string;
  onOk?: () => void;
}

function ModalDelete({ okText, cancelText, trigger, content, title, contentStyle, triggerStyle, onOk }: IModalDelete) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <Dialog open={modalOpen} onOpenChange={isOpen => setModalOpen(isOpen)}>
      <DialogTrigger variant="ghost" className={triggerStyle}>
        {trigger}
      </DialogTrigger>
      <DialogContent className={cn('max-h-[98%]', contentStyle)}>
        <DialogTitle className="flex items-top gap-4 mb-[10px]">
          <Icons.DeleteIcon className="size-[34px]" />
          {title}
        </DialogTitle>
        {content}
        <Separator className="!mt-4" />

        <div className="flex justify-end gap-4">
          <Button variant="link" className="py-3 hover:no-underline" onClick={() => setModalOpen(false)}>
            {cancelText}
          </Button>
          <Button
            variant="default"
            className="py-3 bg-destructive hover:bg-destructive hover:opacity-85"
            onClick={() => {
              setModalOpen(false);
              if (onOk) onOk();
            }}
          >
            <Icons.Delete className="child:fill-white mr-[5px] opacity-80" />
            {okText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

ModalDelete.defaultProps = {
  cancelText: 'Cancel',
  okText: 'Delete',
  content: '',
  contentStyle: '',
  triggerStyle: '',
  onOk: () => undefined,
};

export default ModalDelete;
